module.exports = __webpack_public_path__ + "img/zinc.be5030ca.webp";